/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUserInviteResponse
 */
export interface ControlUserInviteResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUserInviteResponse
     */
    sent: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUserInviteResponse
     */
    failed: Array<string>;
}

/**
 * Check if a given object implements the ControlUserInviteResponse interface.
 */
export function instanceOfControlUserInviteResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sent" in value;
    isInstance = isInstance && "failed" in value;

    return isInstance;
}

export function ControlUserInviteResponseFromJSON(json: any): ControlUserInviteResponse {
    return ControlUserInviteResponseFromJSONTyped(json, false);
}

export function ControlUserInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUserInviteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sent': json['sent'],
        'failed': json['failed'],
    };
}

export function ControlUserInviteResponseToJSON(value?: ControlUserInviteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sent': value.sent,
        'failed': value.failed,
    };
}

